import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    StepperSummaryDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    getFocusRingStyle
} from "../../../../helpers/theme/state";
import {
    getCornerStyle
} from "../../../../helpers/theme/corner";
import {
    webStyle
} from "../../../../utils";

export const STEPPER_SUMMARY_TITLE_VARIANT: keyof NCoreUIKit.Typography = "labelSmallSize";

const stylesheet = StyleSheet.create({
    container: {
        minWidth: 0,
        ...webStyle({
            outlineStyle: "solid",
            outlineWidth: 0
        })
    },
    label: {
        flexDirection: "row",
        alignItems: "center",
        flexShrink: 1,
        flexGrow: 1,
        minWidth: 0
    },
    surface: {
        minWidth: 0
    },
    segment: {
        flex: 1
    }
});

export const useStyles = ({
    isFocusVisible,
    shapeConfigs,
    radiuses,
    borders,
    colors,
    spaces
}: StepperSummaryDynamicStyleType) => {
    const styles = {
        segment: {
            backgroundColor: colors.content.container.danger,
            ...getCornerStyle({
                radius: radiuses.chip,
                shapeConfigs
            })
        } as Mutable<ViewStyle>,
        surface: {
            ...getCornerStyle({
                radius: radiuses.actions,
                shapeConfigs
            }),
            padding: spaces.spacingXs
        } as Mutable<ViewStyle>,
        container: {
            margin: -spaces.spacingXs
        } as Mutable<ViewStyle>,
        label: {
            gap: spaces.spacingXs
        } as Mutable<ViewStyle>
    };

    Object.assign(styles.surface, getFocusRingStyle({
        colorKey: "default",
        isFocusVisible,
        borders,
        colors
    }));

    return styles;
};
export default stylesheet;
